import clsx from "clsx";
import { useMemo } from "react";
import Spinner from "../Spinner";
interface ButtonProps {
	type?: "primary" | "secondary" | "bordered";
	size?: "sm" | "md" | "lg";
	radius?: "lg" | "full";
	block?: boolean;
	disabled?: boolean;
	loading?: boolean;
	children: React.ReactNode;
	leading?: React.ReactNode;
	trailing?: React.ReactNode;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	className?: string;
	id?: string;
	forceDark?: boolean;
}

export default function Button(props: ButtonProps) {
	const memoizedClassNames = useMemo(() => {
		let sizeCn = "";
		switch (props.size) {
			case "sm":
				sizeCn = "btn_size_sm";
				break;
			case "md":
				sizeCn = "btn_size_md";
				break;
			case "lg":
			default:
				sizeCn = "btn_size_lg";
				break;
		}

		let radiusCn = "";
		switch (props.radius) {
			case "lg":
				radiusCn = "btn_radios_lg";
			case "full":
			default:
				radiusCn = "btn_radios_full";
				break;
		}

		let typeCn = "";
		switch (props.type) {
			case "bordered": {
				if (props.disabled) {
					typeCn = "btn_type_bordered_disabled";
				} else {
					typeCn = "btn_type_bordered";
				}
				break;
			}
			case "secondary":
				typeCn = "btn_type_secondary";
				break;
			case "primary":
			default:
				if (props.disabled) {
					typeCn = "btn_type_primary_disabled";
				} else {
					typeCn = props.forceDark ? "btn_type_primary__alway_dark" : "btn_type_primary";
				}
				break;
		}

		return clsx("btn_base", props.block ? "btn_block" : "", sizeCn, radiusCn, typeCn, props.className);
	}, [
		props.type,
		props.size,
		props.radius,
		props.disabled,
		props.loading,
		props.className,
		props.block,
		props.forceDark,
	]);

	const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.stopPropagation();
		if (props.disabled || props.loading) return;

		if (props.onClick) return props.onClick(e);
	};

	return (
		<button className={memoizedClassNames} id={props.id || "btn"} onClick={handleClick}>
			{props.loading && <Spinner size="sm" className="mr-2" />}
			{props.leading}
			<span>{props.children}</span>
			{props.trailing}
		</button>
	);
}
